import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
} from '@mui/material';
import {
  Phone as PhoneIcon,
  Email as EmailIcon,
  Facebook as FacebookIcon,
  Twitter as TwitterIcon,
  Instagram as InstagramIcon,
  Warning as WarningIcon,
} from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#111827',
        color: 'white',
        py: 6,
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={4}>
          {/* Logo and Mission */}
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <Box
                component="img"
                src="/icon/correption.ico"
                alt="Logo"
                sx={{ width: 32, height: 32 }}
              />
              <Typography variant="h6" fontWeight={700}>
                Chennai Anti Bribe Movement
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: '#d1d5db', mb: 2, maxWidth: 500 }}>
              Empowering citizens to fight corruption and build a transparent Tamil Nadu.
              Together, we can create a society where public services are delivered with
              integrity and accountability.
            </Typography>
            <Typography variant="body2" sx={{ color: '#9ca3af', mb: 3 }}>
              லஞ்சம் இல்லாத தமிழ்நாடு - Towards a Corrupt-Free Tamil Nadu
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <motion.div
                whileHover={{ scale: 1.3, rotate: -5 }}
                transition={{ type: 'spring', stiffness: 300 }}
              >
                <IconButton
                  component="a"
                  href="#"
                  sx={{ color: '#9ca3af', '&:hover': { color: 'white' } }}
                >
                  <FacebookIcon sx={{ fontSize: 32 }} />
                </IconButton>
              </motion.div>
              <motion.div
                whileHover={{ scale: 1.3, rotate: -5 }}
                transition={{ type: 'spring', stiffness: 300 }}
              >
                <IconButton
                  component="a"
                  href="#"
                  sx={{ color: '#9ca3af', '&:hover': { color: 'white' } }}
                >
                  <TwitterIcon sx={{ fontSize: 32 }} />
                </IconButton>
              </motion.div>
              <motion.div
                whileHover={{ scale: 1.3, rotate: -5 }}
                transition={{ type: 'spring', stiffness: 300 }}
              >
                <IconButton
                  component="a"
                  href="#"
                  sx={{ color: '#9ca3af', '&:hover': { color: 'white' } }}
                >
                  <InstagramIcon sx={{ fontSize: 32 }} />
                </IconButton>
              </motion.div>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                component={RouterLink}
                to="/about"
                sx={{ color: '#d1d5db', textDecoration: 'none', '&:hover': { color: 'white' } }}
              >
                About Us
              </Link>
              <Link
                component={RouterLink}
                to="/take-action"
                sx={{ color: '#d1d5db', textDecoration: 'none', '&:hover': { color: 'white' }, display: 'flex', alignItems: 'center', gap: 0.5 }}
              >
                <WarningIcon sx={{ fontSize: 16 }} />
                Take Action
              </Link>
              <Link
                component={RouterLink}
                to="/take-action"
                sx={{ color: '#d1d5db', textDecoration: 'none', '&:hover': { color: 'white' }, pl: 3 }}
              >
                Report Corruption
              </Link>
              <Link
                component={RouterLink}
                to="/contact"
                sx={{ color: '#d1d5db', textDecoration: 'none', '&:hover': { color: 'white' } }}
              >
                Contact Us
              </Link>
            </Box>
          </Grid>

          {/* Resources */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
              Resources
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                component={RouterLink}
                to="/take-action"
                sx={{ color: '#d1d5db', textDecoration: 'none', '&:hover': { color: 'white' } }}
              >
                Know Your Rights
              </Link>
              <Link
                href="https://cic.gov.in/sites/default/files/RTI-Act_English.pdf"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: '#d1d5db', textDecoration: 'none', '&:hover': { color: 'white' } }}
              >
                RTI Act 2005
              </Link>
              <Link
                href="https://rtionline.gov.in/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: '#d1d5db', textDecoration: 'none', '&:hover': { color: 'white' } }}
              >
                File RTI Online
              </Link>
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
              Contact Us
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <PhoneIcon sx={{ fontSize: 16, color: '#10b981', mt: 0.5 }} />
                <Box>
                  <Typography variant="caption" sx={{ color: '#9ca3af', display: 'block' }}>
                    ABM Lawyer Vijayarangam
                  </Typography>
                  <Link
                    href="tel:+919952049498"
                    sx={{ color: '#d1d5db', textDecoration: 'none', fontSize: '0.875rem', '&:hover': { color: 'white' } }}
                  >
                    +91 99520 49498
                  </Link>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <EmailIcon sx={{ fontSize: 16, color: '#3b82f6', mt: 0.5 }} />
                <Link
                  href="mailto:tnanitibribemovement@gmail.com"
                  sx={{
                    color: '#d1d5db',
                    textDecoration: 'none',
                    fontSize: '0.875rem',
                    wordBreak: 'break-all',
                    '&:hover': { color: 'white' },
                  }}
                >
                  tnanitibribemovement@gmail.com
                </Link>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;

